import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import $ from 'jquery';
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ModalDialog from '../ui/modal-dialog';
import progress from '../ui/react-ui/progress.jsx';
import PredictionModel from './predictionModel';
import SevenChartListModel from './sevenChartListModel';
import ITSVideoPlayer from '../../utils/ITS-videoPlayer'; // api

import { getAreaTerminals } from '../../api/areaAPI';
import { getPredictionGates, getPredictionGatesItt, getPredictionTerminals, getTrafficTerminalLineAllTime, getTrafficZoneVisitAllTime } from '../../api/predictionAPI';
import { getDeviceCamerasFavorite, addDeviceCamerasFavorite, deleteDeviceCamerasFavorite } from '../../api/deviceAPI';
import { getTerminalRfidVisitLog, getTerminalRfidLogsStats, getTerminalRfidHistStats } from '../../api/rfidAPI';
import { postAuditLogStatistics } from '../../api/settingAPI'; // redux

import { setTvWallCameras, setFavoriteCameras, clearDialogInfo } from '../../redux/traffic-live';

var calInitDateTime = function calInitDateTime() {
  var moveDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var date = '';
  if (moveDay >= 0) date = moment().add(moveDay, 'days').format('YYYY-MM-DD');else date = moment().subtract(Math.abs(moveDay), 'days').format('YYYY-MM-DD');
  var curMinute = moment().minutes();
  var initHour = moment().hour();
  var initMinute = '30';

  if (Number(curMinute) >= 30 && moveDay >= 0) {
    initHour++;
    initMinute = '00';
  } else if (Number(curMinute) < 30 && moveDay < 0) {
    initMinute = '00';
  }

  return {
    date: date,
    initHour: initHour,
    initMinute: initMinute
  };
};

var addZero = function addZero(t) {
  return t < 10 ? '0' + t : t;
};

var t = i18n.getFixedT(null, 'traffic-live');
var gt = i18n.getFixedT(null, 'app');
var TrafficLiveDialog = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      dialogInfo = _useSelector.trafficLive.dialogInfo,
      _useSelector$app = _useSelector.app,
      allTerminalsList = _useSelector$app.allTerminalsList,
      gateList = _useSelector$app.gateList;

  var dispatch = useDispatch();
  var markerTypes = props.markerTypes,
      terminalNoteList = props.terminalNoteList;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      predictionData = _useState2[0],
      setPredictionData = _useState2[1];

  var _useState3 = useState(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      gateIndex = _useState4[0],
      setGateIndex = _useState4[1];

  var _useState5 = useState(-1),
      _useState6 = _slicedToArray(_useState5, 2),
      terminalIndex = _useState6[0],
      setTerminalIndex = _useState6[1];

  var targetType = {
    'gate-station': 'MAP_GATE',
    'terminal-station': 'MAP_TERMINAL',
    'camera': 'MAP_CAMERA',
    'live-traffic': 'MAP_VD'
  };
  useEffect(function () {
    var mode = dialogInfo.mode,
        data = dialogInfo.data; // calculate icon click count

    if (mode === 'live-traffic' || mode === 'gate-station' || mode === 'terminal-station' || mode === 'camera') {
      var target = mode === 'live-traffic' ? data.location : data.name;
      postAuditLogStatistics(contextRoot, true, target, targetType[mode]);
    }

    if (mode === 'gate-station') {
      setGateIndex(_.findIndex(gateList, ['value', data ? data.id : '']));
      getTrafficZoneVisitAllTime(contextRoot, data.id).then(function (result) {
        setPredictionData(result.value);
      });
    } else if (mode === 'terminal-station') {
      setTerminalIndex(_.findIndex(allTerminalsList, ['value', data ? data.id : ''])); // 七櫃

      if (data.id === 'TWKHH_TS03') {
        progress.startSpin();
        var curMin = moment().format('mm');
        var logDateRange = {
          from: moment().subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss'),
          to: moment().format('YYYY-MM-DD HH:mm:ss')
        };
        var FiveMinRange = {
          from: moment().subtract(5, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
          to: moment().format('YYYY-MM-DD HH:mm:ss')
        };
        var twentyFourRange = {
          from: curMin >= 30 ? moment().subtract(1, 'days').format('YYYY-MM-DD HH:30:00') : moment().subtract(1, 'days').format('YYYY-MM-DD HH:00:00'),
          to: curMin >= 30 ? moment().format('YYYY-MM-DD HH:30:00') : moment().format('YYYY-MM-DD HH:00:00')
        };
        var getRfidVisitLog = getTerminalRfidVisitLog(contextRoot, true, logDateRange, 'exit');
        var getRfidFiveMin_entry = getTerminalRfidLogsStats(contextRoot, true, FiveMinRange, 'entry');
        var getRfidFiveMin_exit = getTerminalRfidLogsStats(contextRoot, true, FiveMinRange, 'exit');
        var getRfidTwentyFourHours = getTerminalRfidHistStats(contextRoot, true, twentyFourRange);

        var _getAllTime = getTrafficTerminalLineAllTime(contextRoot, data.id);

        var _getAllTerminals = getAreaTerminals(contextRoot, true, null, null, 0, null, null, true);

        return $.when(getRfidVisitLog, getRfidFiveMin_entry, getRfidFiveMin_exit, getRfidTwentyFourHours, _getAllTime, _getAllTerminals).then(function (result_rfidVisitLog, result_rfidFiveMin_entry, result_rfidFiveMin_exit, result_rfidTwentyFourHours, result_allTime, result_allTerminals) {
          var dialogData = {};
          dialogData.id = 'TWKHH_TS03';
          dialogData.terminalName = data.name;
          dialogData.visitLog = result_rfidVisitLog.content;
          dialogData.twentyFour = _.keyBy(result_rfidTwentyFourHours.content, 'deliverType');
          dialogData.allTime = result_allTime.value; // five minutes

          var fiveDataObj = {
            entryCount: -1,
            exitCount: -1,
            avgWorkingTimeInMins: -1
          };

          if (result_rfidFiveMin_entry.value && result_rfidFiveMin_entry.value.all) {
            fiveDataObj.entryCount = result_rfidFiveMin_entry.value.all.entryCount;
            fiveDataObj.exitCount = result_rfidFiveMin_entry.value.all.exitCount;
            fiveDataObj.avgWorkingTimeInMins = result_rfidFiveMin_entry.value.all.avgWorkingTimeInMins;
          }

          if (result_rfidFiveMin_exit.value && result_rfidFiveMin_exit.value.all) {
            fiveDataObj.entryCount = fiveDataObj.entryCount !== -1 ? fiveDataObj.entryCount + result_rfidFiveMin_exit.value.all.entryCount : result_rfidFiveMin_exit.value.all.entryCount;
            fiveDataObj.exitCount = fiveDataObj.exitCount !== -1 ? fiveDataObj.exitCount + result_rfidFiveMin_exit.value.all.exitCount : result_rfidFiveMin_exit.value.all.exitCount;
            fiveDataObj.avgWorkingTimeInMins = fiveDataObj.avgWorkingTimeInMins !== -1 ? fiveDataObj.avgWorkingTimeInMins + result_rfidFiveMin_exit.value.all.avgWorkingTimeInMins : result_rfidFiveMin_exit.value.all.avgWorkingTimeInMins;
          }

          dialogData.fiveData = fiveDataObj; // inferLineNote, visitLast5minNote

          var curTerminal = _.find(result_allTerminals.content, function (el) {
            return el.id === data.id;
          });

          dialogData.inferLineNote = curTerminal && curTerminal.inferLineNote ? curTerminal.inferLineNote : null;
          dialogData.visitLast5minNote = curTerminal && curTerminal.visitLast5minNote ? curTerminal.visitLast5minNote : null;
          setPredictionData(dialogData);
          progress.done();
        }).catch(function (error) {
          console.log(error);
          progress.done();
        });
      }

      var getAllTime = getTrafficTerminalLineAllTime(contextRoot, data.id);
      var getAllTerminals = getAreaTerminals(contextRoot, true, null, null, 0, null, null, true);
      return $.when(getAllTime, getAllTerminals).then(function (result_allTime, result_allTerminals) {
        var obj = _objectSpread({}, _.clone(result_allTime.value)); // inferLineNote, visitLast5minNote


        var curTerminal = _.find(result_allTerminals.content, function (el) {
          return el.id === data.id;
        });

        obj.inferLineNote = curTerminal && curTerminal.inferLineNote ? curTerminal.inferLineNote : null;
        obj.visitLast5minNote = curTerminal && curTerminal.visitLast5minNote ? curTerminal.visitLast5minNote : null;
        setPredictionData(obj);
      }); // getTrafficTerminalLineAllTime(contextRoot, data.id).then(result => {
      //     setPredictionData(result.value)
      // })
      // getPredictionTerminals(contextRoot, data.id)
    } else if (mode === 'gate-itt') {
      getPredictionGatesItt(contextRoot, data.startGateId, data.destinationGateId).then(function (result) {
        setPredictionData(result.content);
      });
    }
  }, [JSON.stringify(dialogInfo)]);

  var handleNextItem = function handleNextItem(isNext) {
    var mode = dialogInfo.mode;

    if (mode === 'gate-station') {
      var nextIndex = gateIndex + 1 > gateList.length - 1 ? 0 : gateIndex + 1;
      if (isNext === -1) nextIndex = gateIndex - 1 < 0 ? gateList.length - 1 : gateIndex - 1;
      var id = gateList[nextIndex].value; // calculate click count

      postAuditLogStatistics(contextRoot, true, gateList[nextIndex].text, targetType[mode]);
      getTrafficZoneVisitAllTime(contextRoot, id).then(function (result) {
        setGateIndex(nextIndex);
        setPredictionData(result.value);
      });
    } else {
      var _nextIndex = terminalIndex + 1 > allTerminalsList.length - 1 ? 0 : terminalIndex + 1;

      if (isNext === -1) _nextIndex = terminalIndex - 1 < 0 ? allTerminalsList.length - 1 : terminalIndex - 1;
      var _id = allTerminalsList[_nextIndex].value;
      setTerminalIndex(_nextIndex); // calculate click count

      postAuditLogStatistics(contextRoot, true, allTerminalsList[_nextIndex].text, targetType[mode]); // 七櫃

      if (_id === 'TWKHH_TS03') {
        progress.startSpin();
        var curMin = moment().format('mm');
        var logDateRange = {
          from: moment('2023-04-08').subtract(3, 'days').format('YYYY-MM-DD HH:mm:ss'),
          to: moment('2023-04-08').format('YYYY-MM-DD HH:mm:ss')
        };
        var FiveMinRange = {
          from: moment().subtract(5, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
          to: moment().format('YYYY-MM-DD HH:mm:ss')
        };
        var twentyFourRange = {
          from: curMin >= 30 ? moment().subtract(1, 'days').format('YYYY-MM-DD HH:30:00') : moment().subtract(1, 'days').format('YYYY-MM-DD HH:00:00'),
          to: curMin >= 30 ? moment().format('YYYY-MM-DD HH:30:00') : moment().format('YYYY-MM-DD HH:00:00')
        };
        var getRfidVisitLog = getTerminalRfidVisitLog(contextRoot, true, logDateRange);
        var getRfidFiveMin_entry = getTerminalRfidLogsStats(contextRoot, true, FiveMinRange, 'entry');
        var getRfidFiveMin_exit = getTerminalRfidLogsStats(contextRoot, true, FiveMinRange, 'exit');
        var getRfidTwentyFourHours = getTerminalRfidHistStats(contextRoot, true, twentyFourRange);

        var _getAllTime2 = getTrafficTerminalLineAllTime(contextRoot, _id);

        var _getAllTerminals2 = getAreaTerminals(contextRoot, true, null, null, 0, null, null, true);

        return $.when(getRfidVisitLog, getRfidFiveMin_entry, getRfidTwentyFourHours, _getAllTime2, _getAllTerminals2, getRfidFiveMin_exit).then(function (result_rfidVisitLog, result_rfidFiveMin_entry, result_rfidTwentyFourHours, result_allTime, result_allTerminals, result_rfidFiveMin_exit) {
          var dialogData = {};
          dialogData.id = 'TWKHH_TS03';
          dialogData.terminalName = allTerminalsList[_nextIndex].text;
          dialogData.visitLog = result_rfidVisitLog.content;
          dialogData.twentyFour = _.keyBy(result_rfidTwentyFourHours.content, 'deliverType');
          dialogData.allTime = result_allTime.value; // five minutes

          var fiveDataObj = {
            entryCount: -1,
            exitCount: -1,
            avgWorkingTimeInMins: -1
          };

          if (result_rfidFiveMin_entry.value && result_rfidFiveMin_entry.value.all) {
            fiveDataObj.entryCount = result_rfidFiveMin_entry.value.all.entryCount;
            fiveDataObj.exitCount = result_rfidFiveMin_entry.value.all.exitCount;
            fiveDataObj.avgWorkingTimeInMins = result_rfidFiveMin_entry.value.all.avgWorkingTimeInMins;
          }

          if (result_rfidFiveMin_exit.value && result_rfidFiveMin_exit.value.all) {
            fiveDataObj.entryCount = fiveDataObj.entryCount !== -1 ? fiveDataObj.entryCount + result_rfidFiveMin_exit.value.all.entryCount : result_rfidFiveMin_exit.value.all.entryCount;
            fiveDataObj.exitCount = fiveDataObj.exitCount !== -1 ? fiveDataObj.exitCount + result_rfidFiveMin_exit.value.all.exitCount : result_rfidFiveMin_exit.value.all.exitCount;
            fiveDataObj.avgWorkingTimeInMins = fiveDataObj.avgWorkingTimeInMins !== -1 ? fiveDataObj.avgWorkingTimeInMins + result_rfidFiveMin_exit.value.all.avgWorkingTimeInMins : result_rfidFiveMin_exit.value.all.avgWorkingTimeInMins;
          }

          dialogData.fiveData = fiveDataObj; // inferLineNote, visitLast5minNote

          var curTerminal = _.find(result_allTerminals.content, function (el) {
            return el.id === _id;
          });

          dialogData.inferLineNote = curTerminal && curTerminal.inferLineNote ? curTerminal.inferLineNote : null;
          dialogData.visitLast5minNote = curTerminal && curTerminal.visitLast5minNote ? curTerminal.visitLast5minNote : null;
          setPredictionData(dialogData);
          progress.done();
        }).catch(function (error) {
          console.log(error);
          progress.done();
        });
      }

      var getAllTime = getTrafficTerminalLineAllTime(contextRoot, _id);
      var getAllTerminals = getAreaTerminals(contextRoot, true, null, null, 0, null, null, true);
      return $.when(getAllTime, getAllTerminals).then(function (result_allTime, result_allTerminals) {
        var obj = _objectSpread({}, _.clone(result_allTime.value)); // inferLineNote, visitLast5minNote


        var curTerminal = _.find(result_allTerminals.content, function (el) {
          return el.id === _id;
        });

        obj.inferLineNote = curTerminal && curTerminal.inferLineNote ? curTerminal.inferLineNote : null;
        obj.visitLast5minNote = curTerminal && curTerminal.visitLast5minNote ? curTerminal.visitLast5minNote : null;
        setPredictionData(obj);
      }); // getTrafficTerminalLineAllTime(contextRoot, id).then(result => {
      //     setPredictionData(result.value)
      // })
    }
  };

  var handleCloseDialog = function handleCloseDialog() {
    dispatch(clearDialogInfo());
    setPredictionData({});
  };

  if (_.isEmpty(dialogInfo.mode)) return null;
  var dialogTitle = '',
      actions = {};

  var mark = _.find(JSON.parse(markerTypes), function (o) {
    return o.dataType === dialogInfo.mode;
  });

  if (mark) {
    dialogTitle = mark.label;
  } else {
    dialogTitle = t("lbl-".concat(dialogInfo.mode));
  }

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: handleCloseDialog
  });

  var renderWaittingComponent = function renderWaittingComponent(data, dom) {
    // if(_.isEmpty(data)) {
    //     return (<div className='loading' style={{width: '100%', textAlign: 'center', height: '100px', lineHeight: '100px'}}>
    //         <i className='fa fa-circle-notch fa-spin fa-3x fa-fw' />
    //     </div>)
    // }
    return dom;
  };

  var renderContent = function renderContent() {
    switch (dialogInfo.mode) {
      case 'camera':
        return /*#__PURE__*/React.createElement(Camera, {
          data: dialogInfo.data
        });

      case 'roads-event':
        return /*#__PURE__*/React.createElement(RoadsEvent, {
          data: dialogInfo.data
        });

      case 'live-traffic':
        return /*#__PURE__*/React.createElement(LiveTraffic, {
          data: dialogInfo.data
        });

      case 'terminal-station':
        return renderWaittingComponent(predictionData, /*#__PURE__*/React.createElement(TerminalStation, {
          contextRoot: contextRoot,
          data: dialogInfo.data,
          predictionData: predictionData,
          onSwitchItem: function onSwitchItem(isNext) {
            return handleNextItem(isNext);
          },
          terminalNoteList: terminalNoteList
        }));

      case 'gate-station':
        return renderWaittingComponent(predictionData, /*#__PURE__*/React.createElement(GateStation, {
          data: dialogInfo.data,
          predictionData: predictionData,
          onSwitchItem: function onSwitchItem(isNext) {
            return handleNextItem(isNext);
          }
        }));

      case 'forecastPassingTime':
        return /*#__PURE__*/React.createElement(ForecastTime, {
          data: dialogInfo.data
        });

      case 'tvWall':
        return /*#__PURE__*/React.createElement(Tvwall, null);

      case 'errorMessage':
        return /*#__PURE__*/React.createElement("div", {
          className: "errorMessage"
        }, dialogInfo.data.errorMessage);

      default:
        null;
    }
  };

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: 'traffic',
    title: dialogTitle,
    global: true // info={info}
    // infoClassName={cx({'c-error':error})}
    ,
    actions: actions,
    closeAction: "cancel"
  }, renderContent());
});
export default TrafficLiveDialog;

var calCongestionStatus = function calCongestionStatus(val) {
  if (val === 1) return 'color low';
  if (val === 2) return 'color middle';
  if (val === 3) return 'color high';
};

var Camera = /*#__PURE__*/React.memo(function (props) {
  var _useSelector2 = useSelector(function (state) {
    return state.toJS();
  }),
      rights = _useSelector2.sessionObj.rights,
      _useSelector2$envCfg = _useSelector2.envCfg,
      contextRoot = _useSelector2$envCfg.contextRoot,
      isManagementMode = _useSelector2$envCfg.isManagementMode,
      favoriteCameras = _useSelector2.trafficLive.favoriteCameras;

  var dispatch = useDispatch();
  var data = props.data;

  var handleFavoriteDevice = function handleFavoriteDevice(isActive) {
    if (isActive) {
      deleteDeviceCamerasFavorite(contextRoot, data.id).then(function (deletedId) {
        var newFavoriteCameras = _.cloneDeep(favoriteCameras);

        _.remove(newFavoriteCameras, function (el) {
          return el.id === deletedId;
        });

        dispatch(setFavoriteCameras(newFavoriteCameras));
      });
    } else {
      addDeviceCamerasFavorite(contextRoot, data.id).then(function () {
        dispatch(setFavoriteCameras([].concat(_toConsumableArray(favoriteCameras), [data])));
      });
    }
  };

  var isActive = !_.isEmpty(_.find(favoriteCameras, function (o) {
    return o.id === data.id;
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "camera-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "camera-video"
  }, /*#__PURE__*/React.createElement(ITSVideoPlayer, {
    videoData: data
  })), /*#__PURE__*/React.createElement("div", {
    className: "camera-info"
  }, /*#__PURE__*/React.createElement("p", {
    className: "camera-name"
  }, data.name), /*#__PURE__*/React.createElement("p", {
    className: "camera-area"
  }, data.location), _.includes(rights, isManagementMode ? 'evms.map.favorite' : 'web.map.favorite') && /*#__PURE__*/React.createElement("i", {
    className: cx('fa-heart heart-icon', isActive ? 'fas' : 'far'),
    onClick: function onClick() {
      return handleFavoriteDevice(isActive);
    }
  })));
});
var RoadsEvent = /*#__PURE__*/React.memo(function (props) {
  var data = props.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "liveTraffic-content"
  }, /*#__PURE__*/React.createElement("div", null, t('lbl-event-type'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "text-content"
  }, data.type), /*#__PURE__*/React.createElement("div", null, t('lbl-content'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "text-content"
  }, _.map(_.split(data.description, /\r?\n/g), function (text) {
    return /*#__PURE__*/React.createElement("div", null, text);
  })), /*#__PURE__*/React.createElement("div", null, t('lbl-location'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "text-content"
  }, data.location), /*#__PURE__*/React.createElement("div", null, t('lbl-createAt'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "text-content"
  }, data.createdAt));
});
var LiveTraffic = /*#__PURE__*/React.memo(function (props) {
  var data = props.data;
  var noData = t('lbl-no-data');
  var forwardSpeed = _.isNumber(data.forwardSpeed) && Number(data.forwardSpeed) > -1 ? t('lbl-speed', {
    speed: _.round(data.forwardSpeed, 2)
  }) : noData;
  var forwardVolume = _.isNumber(data.forwardVolume) && Number(data.forwardVolume) > -1 ? t('lbl-vehicles', {
    vehicles: _.floor(data.forwardVolume)
  }) : noData; // let forwardOccupancy = _.isNumber(data.forwardOccupancy) && Number(data.forwardOccupancy) > -1 ? _.round(data.forwardOccupancy, 2) + '%' : noData
  // let backwardSpeed, backwardVolume, backwardOccupancy
  // if(data.direction !== "OneWay") {
  //     backwardSpeed = _.isNumber(data.backwardSpeed) && Number(data.backwardSpeed) > -1 ? t('lbl-speed', {speed: _.round(data.backwardSpeed, 2)}) : noData
  //     backwardVolume = _.isNumber(data.backwardVolume) && Number(data.backwardVolume) > -1 ? t('lbl-vehicles', { vehicles: _.floor(data.backwardVolume)}) : noData
  //     backwardOccupancy = _.isNumber(data.backwardOccupancy) && Number(data.backwardOccupancy) > -1 ? _.round(data.backwardOccupancy, 2) + '%' : noData
  // }
  // let combineText = (forwardText, backwardText) => {
  //     if(data.direction === "OneWay")
  //         return `${t('lbl-forward') + forwardText}`
  //     return `${t('lbl-forward') + forwardText}，${t('lbl-backward') + backwardText}`
  // }

  return /*#__PURE__*/React.createElement("div", {
    className: "liveTraffic-content"
  }, /*#__PURE__*/React.createElement("div", null, t('lbl-location'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "text-content"
  }, data.location), /*#__PURE__*/React.createElement("div", null, t('lbl-car-avgspeed'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "text-content"
  }, forwardSpeed), /*#__PURE__*/React.createElement("div", null, t('lbl-car-count'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "text-content"
  }, forwardVolume), /*#__PURE__*/React.createElement("div", null, t('lbl-update-at'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "text-content"
  }, data.updatedAt));
});
var TerminalStation = /*#__PURE__*/React.memo(function (props) {
  var data = props.data,
      predictionData = props.predictionData,
      onSwitchItem = props.onSwitchItem,
      terminalNoteList = props.terminalNoteList,
      contextRoot = props.contextRoot;
  if (_.isEmpty(predictionData)) return null;

  var isDataExist = function isDataExist(val) {
    if (val < 0 || val === undefined) return false;
    return true;
  }; // for seven terminal ----------


  if (predictionData.id === 'TWKHH_TS03') {
    var allTime = predictionData.allTime,
        terminalName = predictionData.terminalName,
        fiveData = predictionData.fiveData,
        twentyFour = predictionData.twentyFour,
        visitLog = predictionData.visitLog,
        _inferLineNote = predictionData.inferLineNote,
        visitLast5minNote = predictionData.visitLast5minNote;
    var _pickUpCurrentTime = allTime.pickUpCurrentTime;

    var _pickUpVehicles = _.isEmpty(_pickUpCurrentTime) ? t('lbl-no-data') : t('lbl-vehicles', {
      vehicles: _.round(_pickUpCurrentTime.trailerLineQty)
    });

    var _pickUpMinutes = _.isEmpty(_pickUpCurrentTime) ? t('lbl-no-data') : t('lbl-minutes', {
      minutes: _.round(_pickUpCurrentTime.estLineDurationMins)
    }); // let returnCurrentTime = allTime.returnCurrentTime
    // let returnVehicles = _.isEmpty(returnCurrentTime) ? t('lbl-no-data') : t('lbl-vehicles', { vehicles: _.round(returnCurrentTime.trailerLineQty) })
    // let returnMinutes = _.isEmpty(returnCurrentTime) ? t('lbl-no-data') : t('lbl-minutes', { minutes: _.round(returnCurrentTime.estLineDurationMins) })
    // let pickUpSameTimeLastWeek = allTime.pickUpSameTimeLastWeek
    // let pickUpVehicles_lastWeek = _.isEmpty(pickUpSameTimeLastWeek) ? t('lbl-no-data') : t('lbl-vehicles', { vehicles: _.round(pickUpSameTimeLastWeek.avgTrailerLineQty) })
    // let pickUpMinutes_lastWeek = _.isEmpty(pickUpSameTimeLastWeek) ? t('lbl-no-data') : t('lbl-minutes', { minutes: _.round(pickUpSameTimeLastWeek.estLineDurationMins) })
    // let returnSameTimeLastWeek = allTime.returnSameTimeLastWeek
    // let returnVehicles_lastWeek = _.isEmpty(returnSameTimeLastWeek) ? t('lbl-no-data') : t('lbl-vehicles', { vehicles: _.round(returnSameTimeLastWeek.avgTrailerLineQty) })
    // let returnMinutes_lastWeek = _.isEmpty(returnSameTimeLastWeek) ? t('lbl-no-data') : t('lbl-minutes', { minutes: _.round(returnSameTimeLastWeek.estLineDurationMins) })
    // handle previous


    var previousDataList_pickup = {};
    var previousDataList_return = {}; // puckup

    if (twentyFour && twentyFour.PickUp && twentyFour.PickUp.stats.length > 0) {
      var pickupList = _.map(twentyFour.PickUp.stats, function (el) {
        return _objectSpread(_objectSpread({}, el), {}, {
          avgVisitDurationMins: _.round(el.avgVisitDurationSecs / 60)
        });
      }); // let pickUpMax = _.maxBy(pickupList, 'avgVisitDurationMins')
      // let pickUpMin = _.minBy(pickupList, 'avgVisitDurationMins')


      _.map(pickupList, function (el) {
        var el_timestamp = moment(el.dateTime).valueOf(); // let newItem = el
        // newItem.isMax = parseInt(el.avgVisitDurationMins) === pickUpMax.avgVisitDurationMins ? true : ''
        // newItem.isMin = parseInt(el.avgVisitDurationMins) === pickUpMin.avgVisitDurationMins ? true : ''

        previousDataList_pickup["".concat(el_timestamp)] = el;
      });
    } // return


    if (twentyFour && twentyFour.Return && twentyFour.Return.stats.length > 0) {
      var returnList = _.map(twentyFour.Return.stats, function (el) {
        return _objectSpread(_objectSpread({}, el), {}, {
          avgVisitDurationMins: _.round(el.avgVisitDurationSecs / 60)
        });
      }); // let returnMax = _.maxBy(returnList, 'avgVisitDurationMins')
      // let returnMin = _.minBy(returnList, 'avgVisitDurationMins')


      _.map(returnList, function (el) {
        var el_timestamp = moment(el.dateTime).valueOf(); // let newItem = el
        // newItem.isMax = parseInt(el.avgVisitDurationMins) === returnMax.avgVisitDurationMins ? true : ''
        // newItem.isMin = parseInt(el.avgVisitDurationMins) === returnMin.avgVisitDurationMins ? true : ''

        previousDataList_return["".concat(el_timestamp)] = el;
      });
    } // previous 24 hours obj (per a half hour)


    var _date = moment().subtract(1, 'days').format('YYYY-MM-DD');

    var _initHour = moment().hour();

    var previousDataObj = {};
    var _dateAry = [_date];
    var theMaxDuration = 0;
    var theMinDuration = 0;

    for (var i = 0; i < 24; i++) {
      var dateTime = "".concat(_date, " $").concat(addZero(_initHour), ":00");
      var timestamp = moment(dateTime).valueOf();
      var pickUpItem = previousDataList_pickup[timestamp] ? previousDataList_pickup[timestamp] : {};
      var returnItem = previousDataList_return[timestamp] ? previousDataList_return[timestamp] : {};
      var pickUpTime = _.isEmpty(pickUpItem) ? undefined : pickUpItem.avgVisitDurationMins;
      var returnTime = _.isEmpty(returnItem) ? undefined : returnItem.avgVisitDurationMins;

      if (returnTime === undefined && pickUpTime === undefined) {
        previousDataObj[timestamp] = {
          avgVisitDurationMins: undefined
        };
      } else {
        pickUpTime = pickUpTime === undefined ? 0 : parseInt(pickUpTime);
        returnTime = returnTime === undefined ? 0 : parseInt(returnTime);

        var avgDuration = _.round((pickUpTime + returnTime) / 2);

        previousDataObj[timestamp] = {
          avgVisitDurationMins: avgDuration
        };
        theMaxDuration = Math.max(theMaxDuration, avgDuration);
        theMinDuration = Math.min(theMinDuration, avgDuration);
      }

      _initHour++;

      if (_initHour > 23) {
        _initHour = 0;
        _date = moment(_date).add(1, 'days').format('YYYY-MM-DD');

        _dateAry.push(_date);
      }
    }

    _.map(previousDataObj, function (el) {
      if (el.avgVisitDurationMins === theMaxDuration) el.isMax = true;else el.isMax = '';
      if (el.avgVisitDurationMins === theMinDuration) el.isMin = true;else el.isMin = '';
    });

    return /*#__PURE__*/React.createElement("div", {
      className: "termanalstation-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "termanalstation-content-info"
    }, /*#__PURE__*/React.createElement("div", {
      className: "data-head"
    }, /*#__PURE__*/React.createElement("i", {
      class: "fas fa-angle-left",
      onClick: function onClick() {
        return onSwitchItem(-1);
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "data-title"
    }, terminalName), /*#__PURE__*/React.createElement("i", {
      class: "fas fa-angle-right",
      onClick: function onClick() {
        return onSwitchItem(1);
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "data-info"
    }, /*#__PURE__*/React.createElement("label", null, t('lbl-live-status'), ":"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
      className: cx('fas fa-circle', calCongestionStatus(allTime.congestionStatus))
    }), allTime.congestionStatusName)), /*#__PURE__*/React.createElement("div", {
      className: cx('data-info')
    }, /*#__PURE__*/React.createElement("label", null, t('lbl-terminal-outside-carcount'), ":"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
      className: _pickUpCurrentTime && calCongestionStatus(_pickUpCurrentTime.congestionStatus)
    }, "".concat(t('lbl-pickUp-return')).concat(_pickUpVehicles, "(").concat(_pickUpMinutes, ")")))), /*#__PURE__*/React.createElement("div", {
      className: cx('data-info')
    }, /*#__PURE__*/React.createElement("label", null, t('lbl-update-at'), ":"), /*#__PURE__*/React.createElement("p", null, moment().format('YYYY-MM-DD HH:mm:ss')))), /*#__PURE__*/React.createElement("div", {
      className: "prediction-model"
    }, /*#__PURE__*/React.createElement(SevenChartListModel, {
      previousData: previousDataObj,
      dateAry: _dateAry,
      visitLog: visitLog
    })));
  } // seven terminal end ----------
  // const { inferLineNote } = terminalNoteList[predictionData.terminalId]


  var updateAt = moment().format('YYYY-MM-DD HH:mm:ss');
  var inferLineNote = predictionData.inferLineNote,
      pickUpCurrentTime = predictionData.pickUpCurrentTime,
      returnCurrentTime = predictionData.returnCurrentTime,
      pickUpSameTimeLastWeek = predictionData.pickUpSameTimeLastWeek,
      returnSameTimeLastWeek = predictionData.returnSameTimeLastWeek,
      terminalLineFuturePredictions = predictionData.terminalLineFuturePredictions;
  var pickUpVehicles = _.isEmpty(pickUpCurrentTime) ? t('lbl-no-data') : t('lbl-vehicles', {
    vehicles: _.round(pickUpCurrentTime.trailerLineQty)
  });
  var returnVehicles = _.isEmpty(returnCurrentTime) ? t('lbl-no-data') : t('lbl-vehicles', {
    vehicles: _.round(returnCurrentTime.trailerLineQty)
  });
  var pickUpMinutes = _.isEmpty(pickUpCurrentTime) ? t('lbl-no-data') : t('lbl-minutes', {
    minutes: _.round(pickUpCurrentTime.estLineDurationMins)
  });
  var returnMinutes = _.isEmpty(returnCurrentTime) ? t('lbl-no-data') : t('lbl-minutes', {
    minutes: _.round(returnCurrentTime.estLineDurationMins)
  });
  var pickUpVehicles_lastWeek = _.isEmpty(pickUpSameTimeLastWeek) ? t('lbl-no-data') : t('lbl-vehicles', {
    vehicles: _.round(pickUpSameTimeLastWeek.avgTrailerLineQty)
  });
  var returnVehicles_lastWeek = _.isEmpty(returnSameTimeLastWeek) ? t('lbl-no-data') : t('lbl-vehicles', {
    vehicles: _.round(returnSameTimeLastWeek.avgTrailerLineQty)
  });
  var pickUpMinutes_lastWeek = _.isEmpty(pickUpSameTimeLastWeek) ? t('lbl-no-data') : t('lbl-minutes', {
    minutes: _.round(pickUpSameTimeLastWeek.estLineDurationMins)
  });
  var returnMinutes_lastWeek = _.isEmpty(returnSameTimeLastWeek) ? t('lbl-no-data') : t('lbl-minutes', {
    minutes: _.round(returnSameTimeLastWeek.estLineDurationMins)
  }); // handle future predictions

  var futurePredictions = {};

  if (terminalLineFuturePredictions.length > 0) {
    var groups = _.groupBy(terminalLineFuturePredictions, 'deliverType');

    var pickUpMax = _.maxBy(groups.PickUp, 'avgTrailerLineQtyPrediction');

    var pickUpMin = _.minBy(groups.PickUp, 'avgTrailerLineQtyPrediction');

    var returnMax = _.maxBy(groups.Return, 'avgTrailerLineQtyPrediction');

    var returnMin = _.minBy(groups.Return, 'avgTrailerLineQtyPrediction');

    _.map(terminalLineFuturePredictions, function (el) {
      var el_time = moment(el.beginTime).valueOf();
      var type = el.deliverType;

      if (type === 'PickUp') {
        el.isMax = parseFloat(el.avgTrailerLineQtyPrediction) === pickUpMax.avgTrailerLineQtyPrediction ? true : '';
        el.isMin = parseFloat(el.avgTrailerLineQtyPrediction) === pickUpMin.avgTrailerLineQtyPrediction ? true : '';
      } else {
        el.isMax = parseFloat(el.avgTrailerLineQtyPrediction) === returnMax.avgTrailerLineQtyPrediction ? true : '';
        el.isMin = parseFloat(el.avgTrailerLineQtyPrediction) === returnMin.avgTrailerLineQtyPrediction ? true : '';
      }

      el.avgTrailerLineQty = _.round(el.avgTrailerLineQty);
      futurePredictions["".concat(el_time, "_").concat(type)] = el;
    });
  } // next 24 hours predictions obj (per a half hour)


  var date = moment().format('YYYY-MM-DD');
  var initHour = moment().hour() + 1;
  var predictionDataObj = {};
  var dateAry = [date];

  for (var _i = 0; _i < 24; _i++) {
    var _dateTime = "".concat(date, " ").concat(addZero(initHour), ":00");

    var _timestamp = moment(_dateTime).valueOf();

    var _returnItem = futurePredictions["".concat(_timestamp, "_Return")] ? futurePredictions["".concat(_timestamp, "_Return")] : {};

    var _pickUpItem = futurePredictions["".concat(_timestamp, "_PickUp")] ? futurePredictions["".concat(_timestamp, "_PickUp")] : {};

    predictionDataObj[_timestamp] = {
      returnItem: _returnItem,
      pickUpItem: _pickUpItem
    };
    initHour++;

    if (initHour > 23) {
      initHour = 0;
      date = moment(date).add(1, 'days').format('YYYY-MM-DD');
      dateAry.push(date);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "termanalstation-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "termanalstation-content-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "data-head"
  }, /*#__PURE__*/React.createElement("i", {
    class: "fas fa-angle-left",
    onClick: function onClick() {
      return onSwitchItem(-1);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "data-title"
  }, predictionData.terminalName), /*#__PURE__*/React.createElement("i", {
    class: "fas fa-angle-right",
    onClick: function onClick() {
      return onSwitchItem(1);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-live-status'), ":"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle', calCongestionStatus(predictionData.congestionStatus))
  }), predictionData.congestionStatusName)), /*#__PURE__*/React.createElement("div", {
    className: cx('data-info', {
      hint: inferLineNote
    })
  }, inferLineNote && /*#__PURE__*/React.createElement(Tooltip, {
    title: inferLineNote
  }, /*#__PURE__*/React.createElement(InfoOutlinedIcon, null)), /*#__PURE__*/React.createElement("label", null, t('lbl-terminal-outside-carcount'), ":"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: pickUpCurrentTime && calCongestionStatus(pickUpCurrentTime.congestionStatus)
  }, "".concat(t('lbl-pickUp')).concat(pickUpVehicles, "(").concat(pickUpMinutes, ")")), "/", /*#__PURE__*/React.createElement("span", {
    className: returnCurrentTime && calCongestionStatus(returnCurrentTime.congestionStatus)
  }, "".concat(t('lbl-return')).concat(returnVehicles, "(").concat(returnMinutes, ")")))), /*#__PURE__*/React.createElement("div", {
    className: cx('data-info', {
      hint: inferLineNote
    })
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-terminal-lastweek-carcount'), ":"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: pickUpSameTimeLastWeek && calCongestionStatus(pickUpSameTimeLastWeek.congestionStatus)
  }, "".concat(t('lbl-pickUp')).concat(pickUpVehicles_lastWeek, "(").concat(pickUpMinutes_lastWeek, ")")), "/", /*#__PURE__*/React.createElement("span", {
    className: returnSameTimeLastWeek && calCongestionStatus(returnSameTimeLastWeek.congestionStatus)
  }, "".concat(t('lbl-return')).concat(returnVehicles_lastWeek, "(").concat(returnMinutes_lastWeek, ")")))), /*#__PURE__*/React.createElement("div", {
    className: cx('data-info', {
      hint: inferLineNote
    })
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-update-at'), ":"), /*#__PURE__*/React.createElement("p", null, updateAt))), /*#__PURE__*/React.createElement("div", {
    className: "prediction-model"
  }, /*#__PURE__*/React.createElement(PredictionModel, {
    type: "terminal",
    predictionData: predictionDataObj,
    dateAry: dateAry
  })));
});
var GateStation = /*#__PURE__*/React.memo(function (props) {
  var data = props.data,
      predictionData = props.predictionData,
      onSwitchItem = props.onSwitchItem;
  if (_.isEmpty(predictionData)) return null;
  var zoneVisitCurrentTime = predictionData.zoneVisitCurrentTime,
      zoneVisitFuturePredictions = predictionData.zoneVisitFuturePredictions,
      zoneVisitSameTimeLastWeek = predictionData.zoneVisitSameTimeLastWeek;
  var zoneGate = "".concat(predictionData.zoneName, "-").concat(predictionData.gateName);
  var updateAt = moment().format('YYYY-MM-DD HH:mm:ss');

  var calHourMin = function calHourMin(min) {
    var hourText = '',
        minText = t('lbl-minutes', {
      minutes: _.round(min)
    });

    if (min > 60) {
      hourText = t('lbl-hours', {
        hours: parseInt(min / 60)
      });
      minText = t('lbl-minutes', {
        minutes: parseInt(min % 60)
      });
    }

    return hourText + minText;
  };

  var currentDuration = _.isEmpty(zoneVisitCurrentTime) ? t('lbl-no-data') : t('lbl-need-times', {
    times: calHourMin(zoneVisitCurrentTime.visitDurationPredictionMins)
  });
  var lastWeekDuration = _.isEmpty(zoneVisitSameTimeLastWeek) ? t('lbl-no-data') : t('lbl-need-times', {
    times: calHourMin(zoneVisitSameTimeLastWeek.visitDurationMins)
  }); // handle future predictions

  var futurePredictions = {};

  if (zoneVisitFuturePredictions.length > 0) {
    var maxItem = _.maxBy(zoneVisitFuturePredictions, 'visitDurationPredictionMins');

    var minItem = _.minBy(zoneVisitFuturePredictions, 'visitDurationPredictionMins');

    _.map(zoneVisitFuturePredictions, function (el) {
      var el_time = moment(el.beginTime).valueOf();
      el.isMax = Number(el.visitDurationPredictionMins) === Number(maxItem.visitDurationPredictionMins) ? true : '';
      el.isMin = Number(el.visitDurationPredictionMins) === Number(minItem.visitDurationPredictionMins) ? true : '';
      futurePredictions[el_time] = el;
    });
  } // next 24 hours predictions obj (per a half hour)


  var date = moment().format('YYYY-MM-DD');
  var initHour = moment().hour() + 1;
  var predictionDataObj = {};
  var dateAry = [date];

  for (var i = 0; i < 24; i++) {
    var dateTime = "".concat(date, " ").concat(addZero(initHour), ":00");
    var timestamp = moment(dateTime).valueOf();
    predictionDataObj[timestamp] = futurePredictions[timestamp] ? futurePredictions[timestamp] : {};
    initHour++;

    if (initHour > 23) {
      initHour = 0;
      date = moment(date).add(1, 'days').format('YYYY-MM-DD');
      dateAry.push(date);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "gatestation-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gatestation-content-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "data-head"
  }, /*#__PURE__*/React.createElement("i", {
    class: "fas fa-angle-left",
    onClick: function onClick() {
      return onSwitchItem(-1);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "data-title"
  }, zoneGate), /*#__PURE__*/React.createElement("i", {
    class: "fas fa-angle-right",
    onClick: function onClick() {
      return onSwitchItem(1);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-live-status'), ":"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
    className: cx('fas fa-circle', calCongestionStatus(zoneVisitCurrentTime.congestionStatus))
  }), zoneVisitCurrentTime.congestionStatusName ? zoneVisitCurrentTime.congestionStatusName : t('lbl-no-data'))), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-prediction-work-time'), ":"), /*#__PURE__*/React.createElement("p", {
    className: zoneVisitCurrentTime && calCongestionStatus(zoneVisitCurrentTime.congestionStatus)
  }, currentDuration)), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-last-week-same-time'), ":"), /*#__PURE__*/React.createElement("p", {
    className: zoneVisitSameTimeLastWeek && calCongestionStatus(zoneVisitSameTimeLastWeek.congestionStatus)
  }, lastWeekDuration)), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-update-at'), ":"), /*#__PURE__*/React.createElement("p", null, updateAt))), /*#__PURE__*/React.createElement("div", {
    className: "prediction-model"
  }, /*#__PURE__*/React.createElement(PredictionModel, {
    type: "gates",
    predictionData: predictionDataObj,
    dateAry: dateAry
  })));
});
var ForecastTime = /*#__PURE__*/React.memo(function (props) {
  var data = props.data;
  return /*#__PURE__*/React.createElement("div", {
    className: "forecast-content"
  }, /*#__PURE__*/React.createElement("div", null, data.location), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-start-point'), ":"), /*#__PURE__*/React.createElement("p", null, data.startArea)), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-destination-point'), ":"), /*#__PURE__*/React.createElement("p", null, data.endArea)), /*#__PURE__*/React.createElement("div", {
    className: "data-info"
  }, /*#__PURE__*/React.createElement("label", null, t('lbl-forecastPassingTime'), ":"), /*#__PURE__*/React.createElement("p", null, t('lbl-minutes', {
    minutes: data.estTravelDuration
  }))));
});
var Tvwall = /*#__PURE__*/React.memo(function () {
  var _useSelector3 = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector3.envCfg.contextRoot,
      _useSelector3$traffic = _useSelector3.trafficLive,
      favoriteCameras = _useSelector3$traffic.favoriteCameras,
      tvWallCameras = _useSelector3$traffic.tvWallCameras;

  var dispatch = useDispatch();

  var handleFavoriteDevice = function handleFavoriteDevice(isActive, data) {
    if (isActive) {
      deleteDeviceCamerasFavorite(contextRoot, data.id).then(function (deletedId) {
        var newFavoriteCameras = _.cloneDeep(favoriteCameras);

        _.remove(newFavoriteCameras, function (el) {
          return el.id === deletedId;
        });

        dispatch(setFavoriteCameras(newFavoriteCameras));
      });
    } else {
      addDeviceCamerasFavorite(contextRoot, data.id).then(function (deletedId) {
        dispatch(setFavoriteCameras([].concat(_toConsumableArray(favoriteCameras), [data])));
      });
    }
  };

  var handleDeleteTv = function handleDeleteTv(el, index) {
    var newData = _.cloneDeep(tvWallCameras);

    newData[index] = {};
    dispatch(setTvWallCameras(newData));
  }; // tvWall count limit is 4


  var tvWallCountLimit = new Array(4);
  return /*#__PURE__*/React.createElement("div", {
    className: "tvwall-content"
  }, _.map(tvWallCountLimit, function (el, index) {
    if (_.isEmpty(tvWallCameras[index])) return /*#__PURE__*/React.createElement("div", {
      className: "frame4",
      key: "null-".concat(index)
    });
    var isActive = !_.isEmpty(_.find(favoriteCameras, function (o) {
      return o.id === tvWallCameras[index].id;
    }));
    return /*#__PURE__*/React.createElement("div", {
      className: "frame4",
      key: "camera-live-".concat(index)
    }, /*#__PURE__*/React.createElement("div", {
      className: "camera-info"
    }, /*#__PURE__*/React.createElement("p", {
      className: "camera-name"
    }, tvWallCameras[index].name), /*#__PURE__*/React.createElement("p", {
      className: "camera-area"
    }, tvWallCameras[index].location), /*#__PURE__*/React.createElement("i", {
      className: cx('fa-heart heart-icon', isActive ? 'fas' : 'far'),
      onClick: function onClick() {
        return handleFavoriteDevice(isActive, tvWallCameras[index]);
      }
    }), /*#__PURE__*/React.createElement("i", {
      className: "fas fa-times delete-camera-icon",
      onClick: function onClick() {
        return handleDeleteTv(el, index);
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "camera-video"
    }, /*#__PURE__*/React.createElement(ITSVideoPlayer, {
      videoData: tvWallCameras[index],
      index: index
    })));
  }));
});